export default {
  follow: 'Follow this workspace',
  following: 'You follow this workspace',
  title: "This workspace's notifications",
  subtitle: 'Get an email for what happens here, whatever you chose for the rest of the organization.',
  kinds: {
    uploadReceived: 'New files',
    uploadPendingModeration: 'Files to review',
  },
  unknownKind: 'Other notification',
  sources: {
    memberScoped: 'Your choice for this workspace',
    member: 'From your choice for the whole organization',
    organization: "From the organization's default",
    registry: 'From the default',
    none: 'Off',
  },
  mandatory: 'Required: cannot be turned off',
  manage: 'Manage my notifications',
  followed: 'You follow this workspace',
  unfollowed: 'You no longer follow this workspace',
  refusals: {
    mandatory: 'This notification is required by email.',
    notEligible: 'This notification no longer concerns you.',
    notSelectable: 'This channel is not available yet.',
    failed: 'The change could not be saved.',
  },
}
